<template>
  <div id="zlog">
    <div class="info">
      <p class="p1">
        <span>运单号：</span>
        <span class="s">7587257387234</span>
      </p>
      <p class="p2">
        <span>承运方：顺丰快递</span>
      </p>
      <p class="p3">
        <span>承运方联系电话：</span>
        <span class="s">023-2476578</span>
      </p>
    </div>

    <!--物流-->
    <ul class="logistic">
      <li class="relativeItem" v-for="(n,index) in 12" :key="index">
        <!-- <img class="big absoluteItem" src="../../assets/zshop/zlog(1).jpg"> -->
        <!-- <img class="big absoluteItem" src="../../assets/zshop/zlog(3).jpg"> -->
        <img class="little absoluteItem" src="../../assets/zshop/zlog(2).jpg">
        <p class="p1">已下单</p>
        <p class="p2">
          您的包裹已经到达重庆XX站，准备进入重庆渝北分
        </p>
        <p class="p3">2019-12-12 13:30:26</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "zlog",
  components: {},
  data() {
    return {};
  },
  methods: {
    /**提交数据 */
    sub_mit() {
      console.log(this.sub_info);
      // return false;
    }
  },
  mounted: function() {
    this.$tool.setTitle("商品评价");
  },
  watch: {}
};
</script>








<style scoped>
#zlog {
  padding: 16px;
  background: white;
}
.info {
  font-size: 15px;
  margin-bottom: 30px;
}
.info p {
  margin-bottom: 9px;
}
.p1 .s {
  font-weight: bold;
}
.p3 .s {
  color: #ff6161;
  font-weight: bold;
}


/**物流 */
.logistic {
  padding-left: 10px;
}
.logistic li{
  padding: 0 8px 0 22px;
  padding-bottom: 30px;
  border-left: 2px solid #ccc;
}
.logistic li:last-child{
  border-left: 2px solid #fff;
}
.logistic .big{
  width: 22px;
  height: 22px;
  top:0;
  left: -12px;
}
.logistic .little{
  width: 12px;
  height: 12px;
  top:5px;
  left: -7px;
}
.logistic .littletop{
  top:3px;
}
.logistic .p1{
  font-size: 17px;
  margin-bottom: 10px;
}
.logistic .p2{
  text-align: justify;
  font-size: 13px;
  margin-bottom: 10px;
}
.logistic .p3{
  font-size: 13px;
  font-weight: bold;
}
</style>
